import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { CrmEvent } from '@cl/shared/models/crm-event.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class CrmEventsService extends BaseService<CrmEvent> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/crm-events/');
    }

    toString(object: CrmEvent): string {
        return object.id.toString();
    }
}
